const { fetchQuery, graphql } = require('react-relay');
const { cookieJarConstants, getUserId } = require('dibs-cookie-jar');
const get = require('lodash.get');

const { getEnvironment } = require('../../relayEnvironmnentProvider.es');

const fetchPinterestSocialAccountsQuery = graphql`
    query fetchPinterestSocialAccountsQuery($userId: String!, $hasUserId: Boolean!) {
        viewer {
            user(userId: $userId) @include(if: $hasUserId) {
                socialNetworks {
                    ... on PinterestSocialNetwork {
                        socialNetwork {
                            name
                        }
                    }
                }
            }
            socialNetworks {
                name
            }
        }
    }
`;

module.exports = function fetchPinterestSocialAccounts() {
    const userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);

    return fetchQuery(getEnvironment(), fetchPinterestSocialAccountsQuery, {
        userId,
        hasUserId: !!userId,
    }).then(data => {
        const socialNetwork = (get(data, 'viewer.socialNetworks') || []).find(
            ({ name }) => name === 'PINTEREST'
        );
        const userSocialNetwork = (get(data, 'viewer.user.socialNetworks') || []).find(
            sn => get(sn, 'socialNetwork.name') === 'PINTEREST'
        );

        return {
            socialNetwork,
            userSocialNetwork,
        };
    });
};



// WEBPACK FOOTER //
// ./assets/js/global/notifications/queries/fetchPinterestSocialAccounts.es.js